import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { advancedTextEditorExtensions, EditorExtensionEnum, TipTapEditor } from '@systemeio/tip-tap';
import { getUrlSchemeOptions, Hint, LocaleEnum, Popover, useTranslation } from '@systemeio/ui';
import { EditablePaymentSettings } from 'modules/profile/payment/types/payment-settings-interface';
import React, { useState } from 'react';
import FormTextarea from 'shared/components/form-textarea';
import { LanguageSwitcher } from 'shared/components/language-switcher/language-switcher';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
import { twJoin } from 'tailwind-merge';
interface AgreementEditorProps {
  tempState: EditablePaymentSettings;
  setTempState: React.Dispatch<React.SetStateAction<EditablePaymentSettings>>;
  locale: LocaleEnum;
  errors: Record<LocaleEnum, string>;
}
function AgreementEditor(t0) {
  const $ = _c(65);
  const {
    setTempState,
    tempState,
    locale,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.settings.payment_page.agreement_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.settings.payment_page.agreement_popover_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Popover label={t2} popoverClassName="w-[200px] sm:w-[350px]">{_temp}</Popover>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedLanguage) {
    t4 = <div className="ml-auto"><LanguageSwitcher changeLanguage={setSelectedLanguage} selectedLanguage={selectedLanguage} /></div>;
    $[6] = selectedLanguage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors mb-2 flex items-center gap-2">{t1}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = tempState.paymentPageAgreement[selectedLanguage];
  let t7;
  if ($[12] !== selectedLanguage || $[13] !== setTempState) {
    t7 = data => setTempState(prev => {
      prev.paymentPageAgreement[selectedLanguage] = data;
      return prev;
    });
    $[12] = selectedLanguage;
    $[13] = setTempState;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== tUi) {
    t8 = getUrlSchemeOptions(tUi);
    $[15] = tUi;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      schemeOptions: t8,
      fileSource: FileSourceEnum.Settings
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== tUi) {
    t10 = getUrlSchemeOptions(tUi);
    $[19] = tUi;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = {
      schemeOptions: t10,
      fileSource: FileSourceEnum.Settings
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = {
      [EditorExtensionEnum.Image]: t9,
      [EditorExtensionEnum.Link]: t11
    };
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = !!errors[selectedLanguage] && "border-red";
  let t14;
  if ($[26] !== t13) {
    t14 = twJoin(t13);
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t14 || $[30] !== t6 || $[31] !== t7) {
    t15 = <TipTapEditor content={t6} onChange={t7} extensionOptions={t12} className={t14} extensions={advancedTextEditorExtensions} />;
    $[28] = t12;
    $[29] = t14;
    $[30] = t6;
    $[31] = t7;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== errors || $[34] !== selectedLanguage) {
    t16 = errors[selectedLanguage] && <p className="text-danger text-sm">{errors[selectedLanguage]}</p>;
    $[33] = errors;
    $[34] = selectedLanguage;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("dashboard.user_settings.payment_page.popover_sales_invoice_footer");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("dashboard.user_settings.payment_page.sales_invoice_footer");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t17 || $[41] !== t18) {
    t19 = <Hint label={t17}>{t18}</Hint>;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== selectedLanguage) {
    t20 = <LanguageSwitcher changeLanguage={setSelectedLanguage} selectedLanguage={selectedLanguage} />;
    $[43] = selectedLanguage;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <div className="mb-2 flex items-center justify-between gap-2">{t19}{t20}</div>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t) {
    t22 = t("dashboard.user_settings.payment_page.sales_invoice_footer");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  const t23 = tempState.salesInvoiceFooter[selectedLanguage] || "";
  let t24;
  if ($[50] !== selectedLanguage || $[51] !== setTempState) {
    t24 = e => setTempState(prevState => ({
      ...prevState,
      salesInvoiceFooter: {
        ...prevState.salesInvoiceFooter,
        [selectedLanguage]: e.target.value
      }
    }));
    $[50] = selectedLanguage;
    $[51] = setTempState;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t22 || $[54] !== t23 || $[55] !== t24) {
    t25 = <FormTextarea placeholder={t22} value={t23} onChange={t24} />;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t21 || $[58] !== t25) {
    t26 = <div className="pt-4">{t21}{t25}</div>;
    $[57] = t21;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t15 || $[61] !== t16 || $[62] !== t26 || $[63] !== t5) {
    t27 = <div className="lg:w-2/3">{t5}{t15}{t16}{t26}</div>;
    $[60] = t15;
    $[61] = t16;
    $[62] = t26;
    $[63] = t5;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  return t27;
}
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
export default AgreementEditor;